<template>
  <div>
    <cube-form
      :model="model"
      :options="options"
      @validate="validateHandler"
      @submit.prevent="submitHandler"
    >
      <cube-form-item :field="fields[0]" />
      <captcha-input
        v-model="model.captcha"
      />
      <div class="cube-form-item-box">
        <cube-form-item :field="fields[1]" />
        <div class="find-pwd-box">
          <get-code
            class="find-pwd-link"
            :mobile="model.mobile"
            :imgcaptcha="model.captcha"
            type="9"
            :is-disabled="false"
          />
        </div>
      </div>
      <cube-form-group>
        <cube-button
          type="submit"
          :primary="true"
        >
          {{ $t('message["196"]') }}
        </cube-button>
      </cube-form-group>
    </cube-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import GetCode from '@/components/mobile/GetCode'
import CaptchaInput from '@/components/mobile/CaptchaInput'
import loginMin from '@/store/account/loginMin'
export default {
  components: {
    GetCode,
    CaptchaInput
  },
  mixins: [loginMin],
  data () {
    return {
      value: 'qq',
      options: {
        scrollToInvalidField: true,
        layout: 'classic' // classic fresh
      },
      validity: {},
      valid: undefined,
      model: {
        mobile: '',
        captcha: '',
        checkcode: ''
      },
      fields: [
        {
          type: 'input',
          modelKey: 'mobile',
          label: '',
          props: {
            placeholder: this.$t('message["1112"]'),
            maxlength: 11
          },
          rules: {
            // required: true,
            type: 'tel'
          },
          messages: {
            // required: '请输入手机号'
          }
        },
        {
          type: 'input',
          modelKey: 'checkcode',
          label: '',
          props: {
            placeholder: this.$t('message["1433"]')
          },
          rules: {
            // required: true
          },
          messages: {
            // required: '请输入验证码'
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('account/login', ['submitting', 'decorators'])
  },
  methods: {
    ...mapActions('account/login', ['login', 'toOrgProject']),
    async submitHandler (e) {
      const obj = Object.assign(this.model, { logintype: 2 })
      const chain = await this.login()
      chain.params(obj)
        .onSuccess(async (raw) => {
          const chain2 = await this.toOrgProject()
          chain2.onSuccess(res => {
            this.getOrgPro(res)
          })
        })
        .onNetSuccess((res) => {
          const error = res.data.error
          if (!error) {
            this.$selefToast({ text: res.data.message })
          } else {
            this.$selefToast({ type: 'error', text: res.data.message || res.data.payload[0].message })
          }
        })
        .setForm(this.form)
        .fetch()
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    }
  }
}
</script>
